import React, { createContext, useState } from "react";

interface GenerateAssignmentsContextType {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
  modelId: any;
  setModelId: (modelId: any) => void;
}

export const GenerateAssignmentsContext = createContext<GenerateAssignmentsContextType>({  
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  modelId: null,
  setModelId: () => {},
});

interface GenerateAssignmentsProviderProps {
  children: React.ReactNode;
}

export const GenerateAssignmentsProvider: React.FC<GenerateAssignmentsProviderProps> = ({
  children,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);
  const [backendFormErrors, setBackendFormErrors] = useState<any>({});
  const [modelId, setModelId] = useState<any>(null);


  const value = {
    showModal,
    setShowModal,
    element,
    setElement,
    backendFormErrors,
    setBackendFormErrors,
    modelId,
    setModelId,
  };
  return (
    <GenerateAssignmentsContext.Provider value={value}>
      {children}
    </GenerateAssignmentsContext.Provider>
  );
};
